module.exports = __webpack_public_path__ + "static/media/d2cb041c.jpg";